import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import throttle from "lodash/throttle";

import getScroll from "shared/util/getScroll";
import noop from "shared/util/noop";

// how close to the bottom of the element to trigger a pageload, in px
const BUFFER = 300;

// how frequently to call the scroll event, in ms
const THROTTLE_TIME = 200;

const Paginate = ({ children, loading, hasMore, loadMore, scrollContainer }) => {
	const ref = useRef(null);

	const onScroll = throttle(() => {
		if (loading || !hasMore) {
			return;
		}

		const scrollTop = getScroll();
		const windowBottom = scrollTop + window.innerHeight;
		const elBottom = ref.current
			? ref.current.getBoundingClientRect().bottom + scrollTop
			: 0;

		if (elBottom - windowBottom < BUFFER) {
			loadMore();
		}
	}, THROTTLE_TIME);

	useEffect(() => {
		scrollContainer.addEventListener("scroll", onScroll, { passive: true });

		return () => {
			scrollContainer.removeEventListener("scroll", onScroll, { passive: true });
		};
	});

	return (
		<div ref={ref}>{children}</div>
	);
};

Paginate.propTypes = {
	scrollContainer: PropTypes.object,
	children: PropTypes.node,
	loading: PropTypes.bool,
	hasMore: PropTypes.bool,
	loadMore: PropTypes.func,
};

Paginate.defaultProps = {
	scrollContainer: window,
	children: null,
	loading: false,
	hasMore: true,
	loadMore: noop,
};

export default Paginate;



// WEBPACK FOOTER //
// ./src/shared/components/Paginate.jsx